module.exports = ".allreadyExported{\r\n  border:solid;\r\n  border-color:red\r\n}\r\n.selected {\r\n  background-color: lightgreen;\r\n}\r\n"